/* eslint-disable */
import {
  Box,
  Button,
  Checkbox,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteLog, getVaults } from '../../stores/slices/vaults/vaultsActions';
import { filterByValue } from '../../utils/filterByValue';
import DeleteAlert from '../Alerts/DeleteAlert';
import VaultModal from './VaultModal';

const Vault = () => {
  const { vaults, loading } = useSelector(state => state.vaults);
  const [filteredVaults, setFilteredVaults] = useState([]);
  const [selectedVaults, setSelectedVaults] = useState([]);
  const [toUpdate, setToUpdate] = useState({ state: false, vault: null });
  const [isDeleting, setIsDeleting] = useState(false);
  const cancelRef = useRef();
  const searchRef = useRef();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenAlert,
    onOpen: onOpenAlertAlert,
    onClose: onCloseAlert,
  } = useDisclosure();
  const toast = useToast();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getVaults());
  }, []);

  useEffect(() => {
    setFilteredVaults(vaults);
  }, [vaults]);

  const handleSelectAll = event => {
    let newSelectedVaults;

    if (event.target.checked) {
      newSelectedVaults = vaults.map(vault => vault.id);
    } else {
      newSelectedVaults = [];
    }

    setSelectedVaults(newSelectedVaults);
  };
  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedVaults.indexOf(id);
    let newSelectedVaults = [];

    if (selectedIndex === -1) {
      newSelectedVaults = newSelectedVaults.concat(selectedVaults, id);
    } else if (selectedIndex === 0) {
      newSelectedVaults = newSelectedVaults.concat(selectedVaults.slice(1));
    } else if (selectedIndex === selectedVaults.length - 1) {
      newSelectedVaults = newSelectedVaults.concat(selectedVaults.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedVaults = newSelectedVaults.concat(
        selectedVaults.slice(0, selectedIndex),
        selectedVaults.slice(selectedIndex + 1)
      );
    }

    setSelectedVaults(newSelectedVaults);
  };
  const onCloseModal = () => {
    onClose();
    setToUpdate({ state: false, vault: null });
  };

  const onDeleteItem = async () => {
    setIsDeleting(true);
    const res = await dispatch(deleteLog({ selectedVaults }));
    await dispatch(getVaults());
    onCloseAlert();
    setIsDeleting(false);
    if (res.type === 'vaults/deleteLog/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      setSelectedVaults([]);
      toast({
        description: 'Item has been deleted',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };

  const filter = data => {
    const text = data.target.value;
    setFilteredVaults(filterByValue(vaults, text));
  };

  const clearInput = () => {
    searchRef.current.value = '';
    setFilteredVaults(vaults);
  };
  return (
    <React.Fragment>
      <Box w={'full'} overflowX={'hidden'} overflowY={'auto'}>
        <VStack spacing={'4'}>
          <Stack
            justifyContent={'space-between'}
            alignContent={'center'}
            direction={{ base: 'column', sm: 'row' }}
            w={'full'}
            spacing={4}
            pr={'2'}
            pb={'2'}
            zIndex={'10'}
            sx={{
              position: '-webkit-sticky',
              /* Safari */
              position: 'sticky',
              top: '0',
            }}
            bg={'white'}
            borderBottom={'1px'}
            borderColor={'gray.500'}
          >
            <InputGroup size="sm" maxW={{ base: '100%', md: '50%' }}>
              <Input
                pr="4.5rem"
                placeholder="Search"
                borderRadius={'4'}
                onChange={filter}
                ref={searchRef}
              />
              <InputRightElement width="4.5rem" justifyContent={'end'}>
                <Button
                  size={'sm'}
                  borderLeftRadius={'none'}
                  onClick={clearInput}
                >
                  Clear
                </Button>
              </InputRightElement>
            </InputGroup>
            <HStack spacing={2}>
              <Button size={'sm'} onClick={onOpen}>
                Add Log
              </Button>
              <Button
                size={'sm'}
                disabled={selectedVaults.length <= 0}
                bg={'red.400'}
                _hover={{
                  color: 'red.400',
                  bg: 'transparent',
                }}
                onClick={onOpenAlertAlert}
              >
                Delete
              </Button>
            </HStack>
          </Stack>
          <Box overflowX={'auto'} w={'full'}>
            <TableContainer whiteSpace={'unset'}>
              <Table
                variant="striped"
                colorScheme="gray"
                display={{
                  base: 'block',
                  md: 'table',
                }}
              >
                <Thead>
                  <Tr>
                    <Th>
                      <Checkbox
                        value="true"
                        onChange={handleSelectAll}
                        isChecked={selectedVaults.length === vaults.length}
                      />
                    </Th>
                    <Th>Published</Th>
                    <Th>Name</Th>
                    <Th>Note</Th>
                    <Th></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {vaults &&
                    (loading ? (
                      <Tr>
                        <Td colSpan={'5'}>
                          <Spinner color="primary" />
                        </Td>
                      </Tr>
                    ) : vaults.length > 0 ? (
                      filteredVaults.map(vault => (
                        <Tr key={vault.id}>
                          <Td>
                            <Checkbox
                              value="true"
                              isChecked={
                                selectedVaults.indexOf(vault.id) !== -1
                              }
                              onChange={event =>
                                handleSelectOne(event, vault.id)
                              }
                            />
                          </Td>
                          <Td>
                            {format(new Date(vault.created_at), 'd MMM h:mm a')}
                          </Td>
                          <Td>{vault.name}</Td>
                          <Td>{vault.note}</Td>
                          <Td align={'right'} textAlign={'right'}>
                            <Button
                              onClick={() => {
                                setToUpdate({
                                  state: true,
                                  vault,
                                });
                                onOpen();
                              }}
                            >
                              Edit
                            </Button>
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={'5'}>No files found</Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </VStack>
      </Box>
      <DeleteAlert
        isOpen={isOpenAlert}
        cancelRef={cancelRef}
        onClose={onCloseAlert}
        isDeleting={isDeleting}
        header={`Delete Log${selectedVaults.length > 1 ? 's' : ''}`}
        body={
          "Are you sure? If you proceed with the deletion, it'll be gone forever."
        }
        onDeleteItem={onDeleteItem}
      />
      {isOpen && (
        <VaultModal
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onCloseModal}
          toUpdate={toUpdate}
        />
      )}
    </React.Fragment>
  );
};

export default Vault;
